import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";
import moment from "moment";

export const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    "Tipo de Documento": item.typeUser?.name || "",
    Documento: item.document || "",
    "E-mail": item.email,
    Assunto: item.subject,
    Mensagem: item.text,
    "Data de Criação": item.createdAt && moment(item.createdAt).isValid()
    ? moment(item.createdAt).format("DD/MM/YYYY")
    : "",
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["Tipo de Documento", "Documento", "E-mail", "Assunto", "Mensagem", "Data de Criação"],
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "messages"); 
};
